import { HTTP_METHOD_GET, HTTP_METHOD_POST } from "./httpMethods";

const AUTH_LOGOUT_PATH = "/api/v1/auth/logout";
export const AUTH_ME_PATH = "/api/v1/auth/me";
const AUTH_UI_PREFERENCES_PATH = "/api/v1/auth/ui-preferences";
const JOBS_PATH = "/api/v1/jobs";

/** Fachlicher Scope und die vom m1member-Backend erlaubten Kontrollwege. */
export const tenantImportApiScope = (tenantId: string) => `tenant:${tenantId.trim()}`;

export function isTenantImportControlRequest(path: string, method: string): boolean {
  const pathname = path.split("?")[0];
  if (pathname.startsWith("/api/v1/public/") || pathname.startsWith("/api/v1/auth/")) return true;
  if (["/api/v1/auth/login", "/api/v1/auth/forgot-password", "/api/v1/auth/reset-password", "/api/v1/auth/register", "/api/v1/auth/email-confirm"].includes(pathname)) return true;
  if (method === HTTP_METHOD_POST && pathname === AUTH_LOGOUT_PATH) return true;
  return method === HTTP_METHOD_GET && (pathname === AUTH_ME_PATH || pathname.startsWith("/api/v1/auth/me/")
    || pathname === AUTH_UI_PREFERENCES_PATH || pathname.startsWith("/api/v1/auth/ui-preferences/")
    || pathname === JOBS_PATH || pathname.startsWith("/api/v1/jobs/")
    || pathname.startsWith("/api/v1/system/startup-status"));
}
